import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { serviceAnfrageSelector } from '../../../modules/selectors/standort/dienstleistungen';
import { InternalLink } from '../form-elements/Link';

function ServiceListPlaceholder() {
    const { serviceUrl } = useParams();
    const serviceAnfrage = useSelector(serviceAnfrageSelector);

    return (
        <div>
            <div className="uk-grid uk-grid-small" data-uk-grid="">
                <div className="uk-width-1-4@m uk-width-1-1">
                    <div className="uk-flex uk-flex-center uk-position-relative">
                        <div>
                            <div className="uk-flex uk-flex-middle">
                                {serviceAnfrage && serviceAnfrage.icon && serviceAnfrage.url === 'serviceAnfrage' && (
                                    <div className="aps-svg-fill uk-width-1-1" dangerouslySetInnerHTML={{ __html: serviceAnfrage.icon }} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="uk-width-expand">
                    <h2 className="uk-margin-remove-top">Ihr Fahrzeug oder Service nicht dabei?</h2>
                    <div>Falls Sie keinen passenden Service finden, können Sie auch gerne eine Anfrage senden</div>
                    <ul>
                        <li>Nach Bearbeitung Ihrer Anfrage melden wir uns bei Ihnen</li>
                    </ul>
                </div>
                <div className="uk-width-1-4@m uk-width-1-1 uk-text-center">
                    <div data-uk-grid="" className="uk-grid-small uk-child-width-1-1">
                        <div className="uk-text-danger">Servicepreis auf Anfrage</div>
                        <div>
                            <InternalLink fullWidth modifier="secondary" to={`/serviceAnfrage/${serviceUrl}`}>
                                zum Formular
                            </InternalLink>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
        </div>
    );
}

export default ServiceListPlaceholder;
